
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lyoVb = parcelRequire("lyoVb");

var $jPe3p = parcelRequire("jPe3p");
function $1d5e52fbdcb49962$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
}
function $1d5e52fbdcb49962$var$sign(v) {
    if (v > 0) return 1;
    else if (v < 0) return -1;
    else return 0;
}
function $1d5e52fbdcb49962$var$sdf(v, p) {
    // https://iquilezles.org/articles/distfunctions2d/
    const r = 0.1;
    const d = 0.5;
    const p2 = createVector(abs(p.x), abs(p.y));
    const b = sqrt(r * r - d * d);
    const r1 = (0, (/*@__PURE__*/$parcel$interopDefault($jPe3p))).Vector.sub(p2, createVector(0, b)).mag() * $1d5e52fbdcb49962$var$sign(d);
    const r2 = (0, (/*@__PURE__*/$parcel$interopDefault($jPe3p))).Vector.sub(p2, createVector(-d, 0)).mag() - r;
    return (p2.y - b) * d > p2.x * b ? r1 : r2;
}
function $1d5e52fbdcb49962$var$cos2(v2) {
    return createVector(Math.cos(v2.x), Math.cos(v2.y));
}
const $1d5e52fbdcb49962$var$ls = "@!_% .~=#.*,:";
let $1d5e52fbdcb49962$var$s = 50;
function $1d5e52fbdcb49962$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(7);
    const poly = [
        $1d5e52fbdcb49962$var$cos2(createVector(0, 2.0).add(0 + 3.40 * (0, $lyoVb.frameN))).mult(0.3),
        $1d5e52fbdcb49962$var$cos2(createVector(0, 1.5).add(1 + 3.45 * (0, $lyoVb.frameN))).mult(0.3),
        $1d5e52fbdcb49962$var$cos2(createVector(0, 3.0).add(2 + 3.50 * (0, $lyoVb.frameN))).mult(0.3),
        $1d5e52fbdcb49962$var$cos2(createVector(0, 2.0).add(3 + 3.55 * (0, $lyoVb.frameN))).mult(0.3),
        $1d5e52fbdcb49962$var$cos2(createVector(0, 1.0).add(4 + 3.60 * (0, $lyoVb.frameN))).mult(0.3)
    ];
    $1d5e52fbdcb49962$var$s = Math.floor((0, $lyoVb.smoothstep)(0, 0.6, (0, $lyoVb.frameN)) * 40 + 10);
    const c = 1 / $1d5e52fbdcb49962$var$s;
    translate((0, $lyoVb.w)(0.5), (0, $lyoVb.h)(0.5));
    noStroke();
    for(let i = $1d5e52fbdcb49962$var$s / -2; i < $1d5e52fbdcb49962$var$s; i++){
        stroke(0, 0, 10);
        line((0, $lyoVb.w)(-0.5), (0, $lyoVb.h)(i * c + 0.5 * c), (0, $lyoVb.w)(0.5), (0, $lyoVb.h)(i * c + 0.5 * c));
        line((0, $lyoVb.w)(i * c + 0.5 * c), (0, $lyoVb.h)(-0.5), (0, $lyoVb.w)(i * c + 0.5 * c), (0, $lyoVb.h)(0.5));
        for(let j = $1d5e52fbdcb49962$var$s / -2; j < $1d5e52fbdcb49962$var$s; j++){
            const x = i * c;
            const y = j * c + 0.0025;
            const n = noise(x * 3.1 + 3.3, y * 20 + 9.1, Math.sin((0, $lyoVb.frameN) * TAU * 2));
            if (n > 0.65) fill(90, 60, 70);
            else if (n > 0.6) fill(0, 50, 80);
            else if (n > 0.5) fill(115, 50, 80);
            else if (n > 0.3) fill(130, 50, 80);
            else fill(30, 20, 86);
            const d = $1d5e52fbdcb49962$var$sdf(poly, createVector(x, y));
            const idx = Math.floor((Math.sin(d * 5 + (0, $lyoVb.frameN) * TAU) + 1) * 8) % $1d5e52fbdcb49962$var$ls.length;
            text($1d5e52fbdcb49962$var$ls.charAt(idx), (0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        }
    }
    resetMatrix();
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $8278bda0311c07bd$var$source = "import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from '../js/common.js';\nimport p5 from 'p5';\n\nexport function setup() {\n	setupCommon();\n}\n\nfunction sign(v) {\n	if (v > 0) return 1;\n	else if (v < 0) return -1;\n	else return 0;\n}\n\nfunction sdf(v, p) {\n	// https://iquilezles.org/articles/distfunctions2d/\n\n	const r = 0.1;\n	const d = 0.5;\n\n	const p2 = createVector(abs(p.x), abs(p.y));\n	const b = sqrt(r * r - d * d);\n\n	const r1 = p5.Vector.sub(p2, createVector(0, b)).mag() * sign(d);\n	const r2 = p5.Vector.sub(p2, createVector(-d, 0)).mag() - r;\n	return ((p2.y - b) * d > p2.x * b) ?\n		r1 :\n		r2;\n\n	return 0.5;\n}\n\nfunction cos2(v2) {\n	return createVector(Math.cos(v2.x), Math.cos(v2.y));\n}\n\nconst ls = '@!_% .~=#.*\\,:'\nlet s = 50;\nexport function draw() {\n	drawCommon();\n\n	background(7);\n	const poly = [\n		cos2(createVector(0, 2.0).add(0 + 3.40 * frameN)).mult(0.3),\n		cos2(createVector(0, 1.5).add(1 + 3.45 * frameN)).mult(0.3),\n		cos2(createVector(0, 3.0).add(2 + 3.50 * frameN)).mult(0.3),\n		cos2(createVector(0, 2.0).add(3 + 3.55 * frameN)).mult(0.3),\n		cos2(createVector(0, 1.0).add(4 + 3.60 * frameN)).mult(0.3),\n	];\n\n	s = Math.floor(smoothstep(0, 0.6, frameN) * 40 + 10);\n	const c = 1 / s;\n\n	translate(w(0.5), h(0.5));\n	noStroke();\n	for (let i = s / -2; i < s; i++) {\n		stroke(0, 0, 10);\n		line(w(-0.5), h(i * c + 0.5 * c), w(0.5), h(i * c + 0.5 * c));\n		line(w(i * c + 0.5 * c), h(-0.5), w(i * c + 0.5 * c), h(0.5));\n\n		for (let j = s / -2; j < s; j++) {\n			const x = i * c;\n			const y = j * c + 0.0025;\n			const n = noise(x * 3.1 + 3.3, y * 20 + 9.1, Math.sin(frameN * TAU * 2));\n			if (n > 0.65) {\n				fill(90, 60, 70);\n			} else if (n > 0.6) {\n				fill(0, 50, 80);\n			} else if (n > 0.5) {\n				fill(115, 50, 80);\n			} else if (n > 0.3) {\n				fill(130, 50, 80);\n			} else {\n				fill(30, 20, 86);\n			}\n\n			const d = sdf(poly, createVector(x, y));\n			const idx = Math.floor((Math.sin(d * 5 + frameN * TAU) + 1) * 8) % ls.length;\n			text(ls.charAt(idx), w(x), h(y));\n		}\n	}\n	resetMatrix();\n}\n";
(0, $gPx2I.make)({
    setup: $1d5e52fbdcb49962$export$de27182ff8187d6c,
    draw: $1d5e52fbdcb49962$export$e529deb2bfd496dc
}, $8278bda0311c07bd$var$source);


//# sourceMappingURL=08.26e7f2b5.js.map
